import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { Constants } from 'src/app/constants';
import { PalleteTypeService } from 'src/app/service/asn/pallet-type.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ShipmentsService } from 'src/app/service/document-control/shipments.service';
import { DatePipe } from '@angular/common'
import { ExportStateService } from 'src/app/service/export-state.service';

@Component({
    selector: 'app-edit-shipments-data',
    templateUrl: './edit-shipments-data.component.html',
    styleUrls: ['./edit-shipments-data.component.scss'],
    standalone: false
})
export class EditShipmentsDataComponent implements OnInit {

  heading: string;
  errormsg
  eventType
  OPDropdown
  emptypackagingValue
  emptypackagingKG
  shipmentDate
  shipmentType
  supplier
  shipmentId;
  selected_position_id: any;
  TierData: any;
  supplierDropdown;
  shipmentTypeDropDown: any;
  userId: any;

  constructor(public dialogRef: MatDialogRef<EditShipmentsDataComponent>, private readonly constants: Constants,
    @Inject(MAT_DIALOG_DATA) public dataStore: any, public datepipe: DatePipe, private readonly shipmentsService: ShipmentsService,
    private readonly ngxUiLoaderService: NgxUiLoaderService, private readonly exportStateService: ExportStateService,) { }

  ngOnInit(): void {
    this.heading = this.dataStore.header;
    this.shipmentId = this.dataStore.shipmentId
    this.supplier = this.dataStore.supplier
    this.shipmentType = this.dataStore.shipmentType
    this.shipmentDate = new Date()
    this.shipmentDate = this.datepipe.transform(this.dataStore.shipmentDate, 'yyyy-MM-dd');
    this.emptypackagingKG = this.dataStore.emptyPackagingKG
    this.emptypackagingValue = this.dataStore.emptyPackagingValue
    this.supplierDropdown = this.dataStore.supplierDropdown
    this.shipmentTypeDropDown = this.dataStore.shipmentTypeDropDown

  }
  validate(event: any, module) {
    const t = event.target.value;
    if (module == "value") {  // NOSONAR
      event.target.value =
        t.indexOf('.') >= 0 ? t.substr(0, t.indexOf('.')) + t.substr(t.indexOf('.'), 3) : t;
    } else if (module == "kg") {  // NOSONAR
      event.target.value =
        t.indexOf('.') >= 0 ? t.substr(0, t.indexOf('.')) + t.substr(t.indexOf('.'), 4) : t;
    }
  }

  keyPressAlphaNumeric(event) {
    const inp = String.fromCharCode(event.keyCode);
    if (/[.0-9]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  close(): void {
    this.dialogRef.close(
      { event: 'CloseEvent' }
    );
  }
  onNoClick(): void {
    this.dialogRef.close({
      event: "NoEvent"
    });
  }
  public saveClick() {

    this.errormsg = ""
    if (this.isValueOk(this.supplier)) {
      this.showError(this.constants.formInputError);
    } else if (this.isValueOk(this.shipmentId)) {
      this.showError(this.constants.formInputError);
    } else if (this.isValueOk(this.shipmentType)) {
      this.showError(this.constants.formInputError);
    } else if (this.emptypackagingKG?.toString().split(".").length > 2) {
      this.showError("invalid decimal");
    } else if (this.emptypackagingValue?.toString().split(".").length > 2) {
      this.showError("invalid decimal");
    } else {
      this.saveAPICall();
    }
  }

  saveAPICall() {
    const userData = sessionStorage?.getItem('FGA');
    if (userData)
    {
      this.userId = JSON.parse(userData)?.user?.userPrincipalName;
    }
    this.errormsg = ""
    this.ngxUiLoaderService.start(this.constants.LoaderComponent)
    const updateObject = {
      flag: 1,
      shipmentId: this.shipmentId,
      p_supplier: this.supplier,
      shipmentTypeId: Number(this.shipmentType),
      shipmentDate: this.shipmentDate,
      emptyPackagingKg: this.formatToDecimal(this.emptypackagingKG,3) ,
      emptyPackagingValue: this.formatToDecimal(this.emptypackagingValue,2)  ,
      createdById: this.userId
    }
    this.ngxUiLoaderService.start(this.constants.LoaderComponent)

    this.shipmentsService.addEditShipment(updateObject).subscribe(
      response => {
        if (response == "Shipment Saved Successfully") {  // NOSONAR
          this.dialogRef.close({
            event: "SaveEvent"
          });
        } else {
          this.showError(this.constants.APIErrorMessage);
        }

      }, _error => {
        this.showError(this.constants.APIErrorMessage);
      });

  }

  formatToDecimal(value: any, decimalPlaces: number): any {
    if (value == '' || value == undefined || value == null) {  // NOSONAR
      return null; 
    }

    const stringValue = value.toString();

    if (!stringValue.includes('.')) {
      return Number(stringValue);
    }

    const [integerPart, decimalPart] = stringValue.split('.');

    return Number(
      integerPart + '.' + decimalPart.substring(0, decimalPlaces)
    );
  }


  showError(message) {
    this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
    this.errormsg = message;
    setTimeout(() => {
      this.errormsg = ""
    }, this.constants.notificationMessageTimeShort);
  }

  isValueOk(param: any): boolean {
    if (param == undefined || param == null || param == "")  // NOSONAR
      {return true;}
    return false;
  }

  ifNullSetZero(param) {
    return Number(param ? param : 0);

  }

}
